module.exports = __webpack_public_path__ + "static/media/caret-up.f5a7b568.svg";